/**
 * Wrapper component for lazy-loaded routes with Suspense
 * Provides consistent loading state for all lazy routes
 */
import React, { Suspense } from 'react';
import PageLoader from './LoadingButton/PageLoader';

const LazyRouteWrapper = ({ children }) => {
  return (
    <Suspense fallback={<PageLoader />}>
      {children}
    </Suspense>
  );
};

export default LazyRouteWrapper;



